export const environment = {
	production: true,
	cognitoUserPoolId: 'eu-central-1_wsUUQQtyA',
	cognitoAppClientId: '2o1h61t40887fpkvgqrg6udlh6',
	redirectUri: '/adsignin',
	oAuthUri: 'https://auth.dev.aciescore.com',
	awsEnvUri: 'https://api.dev.aciescore.com',
	coreEnvironment: 'dev',
	graphqlEndpoint: 'https://graphql.dev.aciescore.com/graphql',
	IpLookupUri: 'https://api.ipify.org?format=json',
};
